import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { LogIn, User } from "lucide-react";
import { getAssetPath } from "@/utils/assetUtils";

interface RiderLayoutProps {
  children: React.ReactNode;
  title?: string;
}

export const RiderLayout = ({ children, title }: RiderLayoutProps) => {
  const [logoLoaded, setLogoLoaded] = useState(false);
  const location = useLocation();
  
  return (
    <div className="min-h-screen bg-white flex flex-col">
      <header className="bg-black p-4 shadow-md">
        <div className="max-w-7xl mx-auto px-4 flex justify-between items-center">
          <Link to="/" className="text-white flex items-center">
            {!logoLoaded && <span className="font-bold text-xl">DISCO</span>}
            <img 
              src={getAssetPath("disco_logo_v2.png")} 
              alt="Disco Logo" 
              className={`h-10 ${logoLoaded ? 'block' : 'hidden'}`}
              onLoad={() => setLogoLoaded(true)}
              onError={() => {
                console.error("Failed to load logo in RiderLayout");
                // Keep text fallback visible
              }}
            />
          </Link>
          
          <Link 
            to="/rider-my-trips" 
            className="text-white flex items-center gap-2 hover:text-white/80 transition-colors"
          >
            <User size={20} />
            <span className="text-sm">My Trips</span>
          </Link>
        </div>
      </header>

      <main className="flex-grow flex flex-col">
        <div className="bg-white w-full">
          {title && (
            <h1 className="text-center text-3xl font-bold my-6 text-black">
              {title}
            </h1>
          )}
          {children}
        </div>
      </main>

      <footer className="bg-black text-white py-3 px-4 text-xs">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center">
          <div>©2025 Disco. All Rights Reserved</div>
          <div className="flex gap-3">
            <Link 
              to="/driver-landing"
              className="hover:underline"
            >
              For Drivers
            </Link>
            <span>|</span>
            <a 
              href="https://www.discoveryconciergeservices.com/terms-conditions" 
              target="_blank" 
              rel="noopener noreferrer"
              className="hover:underline"
            >
              Terms & Conditions
            </a>
            <span>|</span>
            <a 
              href="https://www.discoveryconciergeservices.com/privacy-policy" 
              target="_blank" 
              rel="noopener noreferrer"
              className="hover:underline"
            >
              Privacy Policy
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
};
